import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M6.67 9.902a1.5 1.5 0 1 0-1 0v1.752a.5.5 0 0 0 1 0zm-.5-.914a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M2.043 3.485v-1.01A2.475 2.475 0 0 1 4.518 0h3.59a2.475 2.475 0 0 1 2.474 2.475v1.01h.363c1.049 0 1.899.85 1.899 1.898v9.047c0 1.049-.85 1.899-1.899 1.899H1.898A1.9 1.9 0 0 1 0 14.43V5.383c0-1.048.85-1.898 1.898-1.898zm.95-1.01c0-.843.682-1.526 1.525-1.526h3.59c.842 0 1.525.683 1.525 1.526v1.01h-6.64zm-.605 1.96a.5.5 0 0 0 .26 0h7.33a.5.5 0 0 0 .259 0h.708a.95.95 0 0 1 .95.948v9.047a.95.95 0 0 1-.95.95H1.898a.95.95 0 0 1-.949-.95V5.383a.95.95 0 0 1 .95-.949z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }